import leads from './leads'
import appraisals from './appraisals'

export const queries = {
  leads,
  appraisals,
}
export default queries
